<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
        lg="12"
      >
        <perfil-panel
          :key="perfilData.id"
          :perfil-data="perfilData"
          @refresh-data="getPerfil"
        />
      </v-col>

      <v-col
        cols="12"
        md="12"
        lg="12"
      >
        <v-card class="mt-2 pa-1">
          <v-card-title class="text-uppercase">
            Permissões do Perfil
          </v-card-title>

          <div class="text-right">
            <v-btn
              color="primary"
              class="mb-4 me-3"
              @click="abrirModal"
            >
              <span>Salvar Alterações</span>
            </v-btn>

            <v-btn
              color="ligth"
              outlined
              class="mb-4 me-3"
              @click="cancelarAssociacoes"
            >
              Cancelar
            </v-btn>
          </div>

          <div style="min-height: 4px">
            <v-progress-linear
              v-if="loading"
              indeterminate
            />
          </div>

          <table-funcionalidades
            :modulos="funcionalidadesAgrupadasPorModulos"
            :nova-lista="novaLista"
          />
        </v-card>
      </v-col>
    </v-row>

    <!-- dialog -->
    <v-dialog
      v-model="dialogSalvar"
      max-width="500px"
    >
      <v-card>
        <v-card-title> Tem certeza que deseja salvar? </v-card-title>
        <v-card-actions>
          <v-btn
            color="error"
            outlined
            @click="fecharModal"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="associarFuncionalidades"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secundary"
            />
            <span v-else>OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiBookmarkOutline } from '@mdi/js'
import { mapState } from 'pinia'
import TableFuncionalidades from '@/components/tables/table-funcionalidades/TableFuncionalidades.vue'
import router from '@/router'
import PerfilPanel from '@/views/perfil/PerfilPanel.vue'
import useAuthStore from '@/store/auth'
import PerfilService from '@/services/modules/PerfilService'
import FuncionalidadeService from '@/services/modules/FuncionalidadeService'

export default {
  components: {
    PerfilPanel,
    TableFuncionalidades,
  },

  data() {
    return {
      perfilData: {},
      funcionalidadesAgrupadasPorModulos: [],
      loading: false,
      dialogSalvar: false,
      novaLista: {
        funcionalidadesIds: [],
      },
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    this.getPerfil()
    this.getFuncionalidades()
  },

  methods: {
    async getPerfil() {
      this.perfilData = await PerfilService.getById(router.currentRoute.params.id)
    },

    getFuncionalidades() {
      FuncionalidadeService
        .getFuncionalidadesAgrupadasPorModulos(router.currentRoute.params.id)
        .then(response => {
          this.funcionalidadesAgrupadasPorModulos = response.data.data

          this.funcionalidadesAgrupadasPorModulos.forEach(element => {
            element.funcionalidades.forEach(i => {
              i.filhos.forEach(j => {
                if (j.isChecked) {
                  this.novaLista.funcionalidadesIds.push(j.id)
                }
              })
            })
          })

          setTimeout(() => {
            this.loading = false
          }, 1000)
        })
        .catch(() => {
          this.loading = false
        })
    },

    associarFuncionalidades() {
      this.loading = true
      PerfilService.associarFuncionalidade(router.currentRoute.params.id, this.novaLista)
        .then(() => {
          this.loading = false
          this.getFuncionalidades()
          this.novaLista.funcionalidadesIds = []
          this.fecharModal()
        })
        .catch(() => {
          this.loading = false
        })
    },
    fecharModal() {
      this.dialogSalvar = false
      this.getFuncionalidades()
      this.novaLista = {
        funcionalidadesIds: [],
      }
    },
    abrirModal() {
      this.dialogSalvar = true
    },
    cancelarAssociacoes() {
      this.getFuncionalidades()
      this.novaLista = {
        funcionalidadesIds: [],
      }
    },
  },

  setup() {
    const activeTab = ref(0)
    const tabs = [{ icon: mdiBookmarkOutline, title: 'Perfil' }]

    const headers = [{ text: 'Funcionalidade', value: 'name' }]

    return {
      activeTab,
      tabs,
      headers,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
